export const loadRecaptchaScript = (): Promise<void> => {
  return new Promise((resolve, reject) => {
    const siteKey = import.meta.env.VITE_RECAPTCHA_SITE_KEY;
    if (!siteKey) {
      reject(new Error('VITE_RECAPTCHA_SITE_KEY is not configured'));
      return;
    }
    if (window.grecaptcha) return resolve();

    const script = document.createElement('script');
    script.src = `https://www.google.com/recaptcha/api.js?render=${siteKey}`;
    script.async = true;
    script.defer = true;

    script.onload = () => resolve();
    script.onerror = () => reject(new Error('Failed to load reCAPTCHA'));

    if (!document.body) {
      window.addEventListener(
        'DOMContentLoaded',
        () => {
          document.body.appendChild(script);
        },
        { once: true },
      );
    } else {
      document.body.appendChild(script);
    }
  });
};

export const getRecaptchaToken = async (action = 'submit'): Promise<string> => {
  return new Promise((resolve, reject) => {
    if (!window.grecaptcha) {
      reject(new Error('reCAPTCHA not loaded'));
      return;
    }

    window.grecaptcha.ready(() => {
      window.grecaptcha
        .execute(import.meta.env.VITE_RECAPTCHA_SITE_KEY, { action })
        .then((token) => {
          resolve(token);
        })
        .catch((err) => {
          reject(err);
        });
    });
  });
};
